<template>
    <div class="page" data-page="resources">
        <div class="listingArea">
            
            <!--Left-->
            <div class="leftArea">

                <!--Filters-->
                <div class="pure-g filters">
                    <div class="pure-u-1">
                        <!-- <h1 class="title">Resources</h1> -->

                        <!--Status-->
                        <select
                            v-if="facets['status'].length > 0"
                            v-model="filterOptions.items['status']"
                            @change.prevent="filterUpdated"
                        >
                            <option value="">All Status</option>
                            <option
                                v-for="(status, index) in facets['status']"
                                :key="index"
                                :value="status.value"
                            >
                                {{ status.value }}
                            </option>
                        </select>

                        <!--City-->
                        <select
                            v-if="facets['location.city'].length > 0"
                            v-model="filterOptions.items['city']"
                            @change.prevent="filterUpdated"
                        >
                            <option value="">All City</option>
                            <option
                                v-for="(city, index) in facets['location.city']"
                                :key="index"
                                :value="city.value"
                            >
                                {{ city.value }}
                            </option>
                        </select>

                        <!--Sub Area-->
                        <select
                            v-if="facets['location.sub_area'].length > 0"
                            v-model="filterOptions.items['sub_area']"
                            @change.prevent="filterUpdated"
                        >
                            <option value="">All Sub Areas</option>
                            <option
                                v-for="(area, index) in facets['location.sub_area']"
                                :key="index"
                                :value="area.value"
                            >
                                {{ area.value }}
                            </option>
                        </select>

                        <!--Property Type-->
                        <select
                            v-if="facets['type_of_dwelling'].length > 0"
                            v-model="filterOptions.items['propertyType']"
                            @change.prevent="filterUpdated"
                        >
                            <option value="">All Property Types</option>
                            <option
                                v-for="(type, index) in facets['type_of_dwelling']"
                                :key="index"
                                :value="type.value"
                            >
                                {{ type.value }}
                            </option>
                        </select>

                        <div
                            class="checkbox"
                            data-id="hasImage"
                            @click.prevent="filterCheckbox('hasImage')"
                            :class="{active: filterOptions.items['hasImage']}"
                        >
                            <ion-icon name="checkmark-circle"></ion-icon> Has Image
                        </div>

                        <div
                            class="checkbox"
                            data-id="openHouse"
                            @click.prevent="filterCheckbox('openHouse')"
                            :class="{active: filterOptions.items['openHouse']}"
                        >
                            <ion-icon name="checkmark-circle"></ion-icon> Open House
                        </div>

                        <input
                            type="text"
                            class="search"
                            placeholder="Search here"
                            v-model="searchText"
                            autocomplete="off"
                            spellcheck="false"
                            ref="searchInput"
                        />

                        <a href="#0" @click.prevent="clearFilters()" class="btn secondary">
                            <ion-icon name="trash"></ion-icon>
                        </a>
                    </div>
                </div>

                <div id="mainList">
                    
                    <div v-if="loading" class="loading"></div>
                    
                    <!--Parks-->
                    <ul
                        v-if="filterItem === 'bc_parks' && parks !== null"
                        class="dataList list"
                    >
                        <li
                            v-for="(park, index) in filteredList"
                            :key="index"
                            class="dataItem"
                        >
                            <div
                                class="image"
                                :style="'background-image:url(http://bcparks.ca'+ park.path +'photos/images/01.jpg);'"
                                @error="imgPlaceholder($event, park.path)"
                            ></div> <!-- @error="imgPlaceholder($event, park.path)" -->
                            <h3 class="name" v-html="park.ParkNameBasic"></h3>
                            <a :href="park.url" target="_blank" class="btn secondary">
                                <ion-icon name="arrow-redo"></ion-icon>
                            </a>
                            <a href="#0" @click.prevent="panTo('park', park)" class="btn secondary">
                                <ion-icon name="navigate"></ion-icon>
                            </a>
                        </li>
                    </ul>

                    <!--Properties-->
                    <div v-else-if="filterItem === 'properties' && properties !== null">
                        <ul
                            v-if="properties.length > 0"
                            class="dataList list pure-g"
                            ref="propertiesList"
                            v-on:scroll.passive="handleScroll"
                        >
                            <li
                                v-for="(property, index) in properties"
                                :key="property.mls_no"
                                class="dataItem pure-u-1 pure-u-lg-1-2 property"
                                :class="{
                                    first: index === 0
                                }"
                                @click.prevent="openModal(property)"
                                @mouseover.prevent="openPopup('property', property)"
                                @mouseleave.prevent="closePopups"
                            >
                                <div class="dataItemWrapper">

                                    <div
                                        v-if="typeof(property.images.mls_images) !== 'undefined'"
                                        class="image"
                                        :style="'background-image:url('+ property.images.mls_images[0].full_path +');'"
                                    >
                                    </div>
                                    <div v-else class="image emptyImage"><p>Image Coming Soon...</p></div>

                                    <div class="badges">
                                        <span class="badge grey">{{ property.type_of_dwelling | propertyType }}</span>
                                        <span v-if="property.status === 'Sold'" class="badge red">Sold</span>
                                        <span v-if="property.status === 'Off Market'" class="badge yellow">Off Market</span>
                                        <span v-if="property.status === 'Terminated'" class="badge red">Terminated</span>
                                        <span v-if="isNewProperty(property.tms)" class="badge">Added {{ property.tms | propertyAddedDate }}</span>
                                    </div>
                                    
                                    <div class="dataItemContent">

                                        <h3 class="name">
                                            ${{ property.list_price | formatPrice }}
                                            <span class="mls_no">{{ property.mls_no }}</span>
                                        </h3>
                                        <p class="details">
                                            <span class="bed">{{ property.total_bedrooms }} bed</span>
                                            <span class="bath">{{ property.total_baths }} bath</span>
                                            <span class="sqft">{{ property.floor_area }} sqft</span>
                                        </p>
                                        <p class="address">
                                            {{ property | fullAddress }}
                                        </p>

                                        <a
                                            href="#0"
                                            @click.prevent="panTo('property', property)"
                                            @mouseleave.prevent="closePopups"
                                            class="btn secondary actionBtn hint hint--right"
                                            data-hint="Zoom map to this property"
                                        >
                                            <ion-icon name="navigate"></ion-icon>
                                        </a>
                                        <a 
                                            href="#0"
                                            class="btn secondary actionBtn hint hint--right"
                                            data-hint="Save Property"
                                        >
                                            <ion-icon name="star"></ion-icon>
                                        </a>
                                        <a 
                                            href="#0"
                                            class="btn green actionBtn hint hint--right"
                                            data-hint="View Property"
                                        >
                                            <ion-icon name="arrow-redo"></ion-icon>
                                        </a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <a  
                            v-if="properties.length > 0 && showScrollToTopBtn"
                            href="#0"
                            class="scrollToTopBtn"
                            @click.prevent="scrollTo(0)"
                        >
                            <ion-icon name="arrow-up"></ion-icon>
                        </a>
                        <div v-if="properties.length === 0" class="emptyArea">
                            <p class="empty">Nothing here...</p>
                            <a href="#0" class="btn secondary" @click.prevent="clearFilters()">Clear filters</a>
                        </div>
                    </div>

                </div>
            </div><!--/leftArea-->

            <!--Right-->
            <div class="rightArea">
                <div id="map">
                    <MglMap
                        :accessToken="accessTokens[0]"
                        :mapStyle.sync="mapSettings.style"
                        :center="mapSettings.center"
                        :zoom="mapSettings.zoom"
                        @load="initMap"
                    >
                    </MglMap>
                </div>
                <div v-if="bc_area_info" class="map_layer_info">
                    {{ bc_area_info }}
                    <ion-icon v-if="bcAreaClickId" @click="removePolygonArea" name="close-circle"></ion-icon>
                </div>
                <div class="map_info">{{ showingInfo }}</div>
            </div><!--/rightArea-->
            
        </div>

        <!--Property Modal-->
        <div class="modal property" :class="{active: showModal}">
            <div class="modal_dimmer">
                <div v-if="property !== null" class="modal_content">
                    
                    <a href="#0" class="closeBtn" @click.prevent="closeModal()">
                        <ion-icon name="close-circle"></ion-icon>
                    </a>

                    <div class="pure-g">

                        <!--Left-->
                        <div class="pure-u-1 pure-u-lg-17-24 left">
                            <div
                                v-if="typeof(property.images.mls_images) !== 'undefined'"
                                class="image propertyImage"
                                :style="'background-image:url('+ property.images.mls_images[0].full_path +');'"
                            >
                            </div>
                            <div v-else class="image emptyImage"><p>Image Coming Soon...</p></div>

                            <h1 class="address">
                                {{ property | fullAddress }}
                            </h1>
                        </div>

                        <!--Right-->
                        <div class="pure-u-1 pure-u-lg-7-24 right">
                            <p class="label">Price</p>
                            <h3 class="name">
                                ${{ property.list_price | formatPrice }}
                            </h3>

                            <p class="label">MLS No</p>
                            <h3><span class="mls_no">{{ property.mls_no }}</span></h3>
                        </div>

                    </div><!--/pure-g-->
                </div><!--/modal_content-->
                <div class="dimmer" @click.prevent="closeModal()"></div>
            </div><!--/modal_dimmer-->
        </div><!--/property-->

    </div>
</template>

<script>
    import moment from 'moment'
    import algoliasearch from 'algoliasearch'
    import Mapbox from 'mapbox-gl/dist/mapbox-gl'
    import 'mapbox-gl/dist/mapbox-gl.css'
    import { MapboxStyleSwitcherControl } from 'mapbox-gl-style-switcher'
    import 'mapbox-gl-style-switcher/styles.css'
    import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'
    import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'
    import MapboxDraw from '@mapbox/mapbox-gl-draw'
    import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
    import {
        MglMap,
        MglGeojsonLayer,
        MglPopup
    } from 'vue-mapbox/dist/vue-mapbox.umd.js'
    import Banner from '../components/Banner.vue'
    const parksData = require('../data/parks.json')
    const bcAreasData = require('../data/bc_areas.json')

    export default {
        metaInfo: {
            title: 'Resources',
            meta: [
                {
					property: 'og:title',
                    content: 'Resources',
                    template: '%s | OneMgl Community',
                },
                {
					property: 'twitter:title',
					content: 'Resources',
					template: '%s | OneMgl Community'
				}
            ]
        },
        components: {
            Banner,
            MglMap,
            MglGeojsonLayer,
            MglPopup
        },
        data(){
            return{
                page: 1,
                hitsPerPage: 50,
                maxHits: false,
                loading: true,
                moreLoading: false,
                filterItem: 'properties',
                filters: [
                    {
                        title: 'Parks',
                        id: 'bc_parks'
                    },
                    {
                        title: 'Properties',
                        id: 'properties'
                    }
                ],
                searchText: '',
                parks: null,
                accessTokens: [
                    'pk.eyJ1IjoibWlrZWhhbWlsdG9uMDAiLCJhIjoiNDVjS2puUSJ9.aLvWM5BnllUGJ0e6nwMSEg',
                    'pk.eyJ1IjoiYnBhY2h1Y2EiLCJhIjoiY2lxbGNwaXdmMDAweGZxbmg5OGx2YWo5aSJ9.zda7KLJF3TH84UU6OhW16w',
                    'pk.eyJ1IjoibW9uZ29sbGlzdCIsImEiOiIwYjBhZjRhNjJiNmFlNWYzODFlNmU5MGY4MzFkZTExNSJ9.Dz7pcSgryLYQAtoKLryzow'
                ],
                mapSettings: {
                    style: 'mapbox://styles/mapbox/dark-v10?optimize=true',
                    center: [-123.1207, 49.2827],
                    zoom: 9
                },
                algoliaSettings: {
                    appId: '47TFSLIJYK',
                    appKey: 'ac98247ad173f9549cfeeccbf54e8396', // 114745efaef1a86053a052b1ffca88d9
                    index: 'dev_hx__properties'
                },
                algoliaFilters: null,
                facets: {
                    'status': [],
                    'location.city': [],
                    'location.sub_area': [],
                    'type_of_dwelling': []
                },
                properties: null,
                filterOptions: {
                    query: '',
                    items: {
                        city: '',
                        sub_area: '',
                        status: '',
                        hasImage: false,
                        openHouse: false,
                        propertyType: ''
                    }
                },
                defaultFilterOptions: null,
                showingInfo: 'Showing: 0 - 0 of 0 (Page: 1/1)',
                showScrollToTopBtn: false,
                sampleGeoJson: null,
                polygonSearch: null,
                searchType: 'boundary',
                bc_area_ids: [],
                bc_area_info: null,
                bcAreaHoverId: null,
                bcAreaClickId: null,
                showModal: false,
                property: null
            }
        },
        created(){
            this.map = null
            this.popup = null
            let defaultItems = this.filterOptions.items
            this.defaultFilterOptions = defaultItems

            this.initAlgolia()
            this.getResources(this.filterItem)
        },
        methods: {
            /**
             * Algolia
             */
            
            initAlgolia(){
                this.searchClient = algoliasearch(
                    this.algoliaSettings.appId,
                    this.algoliaSettings.appKey
                )
                this.searchIndex = this.searchClient.initIndex(this.algoliaSettings.index)

                Object.keys(this.facets).forEach((facetId) => {
                    this.setFacet(facetId)
                })
            },
            searchProperties(){
                this.setFilters()

                // Set Bounds
                let lat1 = this.bounds._ne.lat
                let lng1 = this.bounds._ne.lng
                let lat2 = this.bounds._sw.lat
                let lng2 = this.bounds._sw.lng

                let options = {
                    query: this.filterOptions.query,
                    boundingBox: [lat1, lng1, lat2, lng2]
                }

                // Geo Search
                let searchQuery = {
                    attributesToRetrieve: ['*'],
                    page: this.page - 1,
                    hitsPerPage: this.hitsPerPage,
                    insideBoundingBox: [options.boundingBox]
                }

                // Polygon Search
                if(this.polygonSearch !== null){
                    searchQuery = {
                        attributesToRetrieve: ['*'],
                        page: this.page - 1,
                        hitsPerPage: this.hitsPerPage,
                        insidePolygon: [this.polygonSearch]
                    }
                }

                // Filters
                if(this.algoliaFilters){
                    searchQuery.filters = this.algoliaFilters
                }
                
                // Do Search
                this.searchIndex.search(options.query, searchQuery).then(results => {

                    console.log('Properties: ', results)

                    this.loading = false
                    this.moreLoading = false

                    // if(this.page === 1){
                    this.properties = results.hits
                    // }else{
                        // this.properties = this.properties.concat(results.hits)
                    //     this.properties = results.hits
                    // }

                    this.setShowingInfo(results)
                    this.addMarkers()

                    if(this.page > 1){
                        this.scrollTo(0)
                    }
                })
                .catch(err => {
                    console.log('Properties error: ', err)
                })
            },
            getPropertyHtml(property){
                let propertyPrice = this.$options.filters.formatPrice(property.list_price)
                let propertyAddress = this.$options.filters.fullAddress(property)
                let propertyType = this.$options.filters.propertyType(property.type_of_dwelling)
                let propertyImage = ''
                let propertyBadges = `<span class="badge grey">${propertyType}</span>`

                // Badges
                if(property.status === 'Sold'){
                    propertyBadges += `<span class="badge red">Sold</span>`
                }
                if(this.isNewProperty(property.entry_date)){
                    propertyBadges += `<span class="badge">New</span>`
                }

                // Images
                if(typeof(property.images.mls_images) !== 'undefined'){
                    propertyImage = '<div class="image" style="background-image:url('+ property.images.mls_images[0].full_path +');"></div>'
                }else{
                    propertyImage = '<div class="image emptyImage"><p>Image Coming Soon...</p></div>'
                }

                let propertyHtml = `<div class="popupContent property">
                    <div class="dataItem property">
                        <div class="dataItemWrapper">
                            ${propertyImage}
                            <div class="badges">
                                ${propertyBadges}
                            </div>
                            <div class="dataItemContent">
                                <h3 class="name">
                                    $${propertyPrice}
                                    <span class="mls_no">${property.mls_no}</span>
                                </h3>
                                <p class="details">
                                    <span class="bed">${property.total_bedrooms} bed</span>
                                    <span class="bath">${property.total_baths} bath</span>
                                    <span class="sqft">${property.floor_area} sqft</span>
                                    <span class="year">Built in ${property.year_built}</span>
                                </p>
                                <p class="address">${propertyAddress}</p>
                                <p class="providedBy">${property.list_office_rep1_name}</p>
                            </div>
                        </div>
                    </div>
                </div>`

                return propertyHtml
            },
            getAlgoliaCoordinates(coordinates){
                let algoliaPoints = []

                for(let i = 0; i < coordinates[0].length; i++){
                    let lat = coordinates[0][i][1]
                    let lng = coordinates[0][i][0]

                    algoliaPoints.push(lat)
                    algoliaPoints.push(lng)
                }

                return algoliaPoints
            },
            setFacet(categoryId){

                let options = {
                    query: '',
                    category: categoryId 
                }

                this.searchIndex.searchForFacetValues({
                    facetName: options.category,
                    facetQuery: options.query,
                    maxFacetHits: 100
                }, (err, content) => {
                    if(err) throw err
                    console.log('Facet '+ categoryId +': ', content)
                    this.facets[categoryId] = content.facetHits
                })
            },
            setFilters(){
                if(this.filterOptions.items !== null){
                    let searchFilters = ''

                    // Price
                    if(this.filterOptions.items.price && this.filterOptions.items.price !== null){
                        if(this.filterOptions.items.price.min !== 0){
                            if(searchFilters !== '') searchFilters += ' AND '
                            searchFilters += 'list_price > ' + this.filterOptions.items.price.min
                        }
                        if(!isNaN(this.filterOptions.items.price.max)){
                            if(searchFilters !== '') searchFilters += ' AND '
                            searchFilters += 'list_price < ' + this.filterOptions.items.price.max
                        }
                    }

                    // Bed
                    if(this.filterOptions.items.bed && this.filterOptions.items.bed != null){
                        if(this.filterOptions.items.bed.length > 0){
                            if(searchFilters !== '') searchFilters += ' AND '
                            searchFilters += '('
                        }
                        for(var i = 0; i < this.filterOptions.items.bed.length; i++){
                            if(i > 0) searchFilters += ' OR '

                            if(this.filterOptions.items.bed[i] < 4){
                                searchFilters += 'total_bedrooms = ' + this.filterOptions.items.bed[i]
                            }else{
                                searchFilters += 'total_bedrooms >= ' + this.filterOptions.items.bed[i]
                            }
                        }
                        if(this.filterOptions.items.bed.length > 0){
                            searchFilters += ')'
                        }
                    }

                    // Bath
                    if(this.filterOptions.items.bath && this.filterOptions.items.bath != null){
                        if(this.filterOptions.items.bath.length > 0){
                            if(searchFilters !== '') searchFilters += ' AND '
                            searchFilters += '('
                        }
                        for(var i = 0; i < this.filterOptions.items.bath.length; i++){
                            if(i > 0) searchFilters += ' OR ' 

                            if(this.filterOptions.items.bath[i] < 4){
                                searchFilters += 'total_baths = ' + this.filterOptions.items.bath[i]
                            }else{
                                searchFilters += 'total_baths >= ' + this.filterOptions.items.bath[i]
                            }
                        }
                        if(this.filterOptions.items.bath.length > 0){
                            searchFilters += ')'
                        }
                    }

                    // Sqft
                    if(this.filterOptions.items.sqft && this.filterOptions.items.sqft != null){
                        if(this.filterOptions.items.sqft.min !== '300'){
                            if(searchFilters !== '') searchFilters += ' AND '
                            searchFilters += 'floor_area >= ' + this.filterOptions.items.sqft.min
                        }
                        if(this.filterOptions.items.sqft.max !== '5000+'){
                            if(searchFilters !== '') searchFilters += ' AND '
                            searchFilters += 'floor_area <= ' + this.filterOptions.items.sqft.max
                        }
                    }

                    // Age
                    if(this.filterOptions.items.builtIn){
                        
                        let year = new Date().getFullYear(),
                            builtinmin = 0,
                            builtinmax = 50

                        if(this.filterOptions.items.builtIn.min !== '0'){
                            builtinmin = parseInt(this.filterOptions.items.builtIn.min)
                        }
                        if(this.filterOptions.items.builtIn.max !== '50+'){
                            builtinmax = parseInt(this.filterOptions.items.builtIn.max)
                        }
                        if(builtinmax < 50){
                            if(searchFilters !== '') searchFilters += ' AND '
                            searchFilters += 'year_built >= '+ (year - builtinmax)
                        }
                        if(builtinmin > 0){
                            if(searchFilters !== '') searchFilters += ' AND '
                            searchFilters += 'year_built <= '+ (year - builtinmin)
                        }
                    }

                    // Property Type
                    if(this.filterOptions.items.propertyType && this.filterOptions.items.propertyType != null){
                        if(searchFilters !== '') searchFilters += ' AND '
                        searchFilters += 'type_of_dwelling: "' + this.filterOptions.items.propertyType + '"'
                    }

                    // Building Types
                    if(this.filterOptions.items.buildingTypes){

                        if(this.filterOptions.items.buildingTypes.length > 0){
                            if(searchFilters !== '') searchFilters += ' AND '
                            searchFilters += '('
                        }
                        
                        for(var i = 0; i < this.filterOptions.items.buildingTypes.length; i++){
                            if(i > 0) searchFilters += ' OR '
                            if(this.filterOptions.items.buildingTypes[i] === 'concrete'){
                                searchFilters += '(foundation: "Concrete Perimeter" OR foundation: "Concrete Slab" OR foundation: "Concrete Block")'
                            }else if(this.filterOptions.items.buildingTypes[i] === 'full-rain-screen'){
                                searchFilters += '(rain_screen: "Full" OR rain_screen: "Partial")'
                            }else if(this.filterOptions.items.buildingTypes[i] === 'rentals-allowed'){
                                searchFilters += 'no_of_rentals_allowed_available=1'
                            }else if(this.filterOptions.items.buildingTypes[i] === 'pets-allowed'){
                                searchFilters += 'no_of_pets_available=1'
                            }else if(this.filterOptions.items.buildingTypes[i] === 'property-view'){
                                searchFilters += 'view=1'
                            }
                            
                            // TODO: Find out the value
                            // else if(this.filterOptions.items.buildingTypes[i] === 'live-work-studio'){
                            // 	searchFilters += 'studio_units!=""'
                            // }
                        }
                        if(this.filterOptions.items.buildingTypes.length > 0){
                            searchFilters += ')'
                        }
                    }

                    // Status
                    if(this.filterOptions.items.status){
                        if(searchFilters !== '') searchFilters += ' AND '
                        searchFilters += 'status: "' + this.filterOptions.items.status + '"'
                    }

                    // City
                    if(this.filterOptions.items.city){
                        if(searchFilters !== '') searchFilters += ' AND '
                        searchFilters += 'location.city: "'+ this.filterOptions.items.city +'"'
                    }

                    // Area
                    if(this.filterOptions.items.area){
                        if(searchFilters !== '') searchFilters += ' AND '
                        searchFilters += 'location.area: "'+ this.filterOptions.items.area +'"'
                    }

                    // Sub Area
                    if(this.filterOptions.items.sub_area){
                        if(searchFilters !== '') searchFilters += ' AND '
                        searchFilters += 'location.sub_area: "'+ this.filterOptions.items.sub_area +'"'
                    }

                    // Sub Area
                    if(this.filterOptions.items.subarea){
                        if(searchFilters !== '') searchFilters += ' AND '
                        searchFilters += 'location.sub_area: "'+ this.filterOptions.items.subarea +'"'
                    }

                    // Has Image
                    if(this.filterOptions.items.hasImage){
                        if(searchFilters !== '') searchFilters += ' AND '
                        searchFilters += 'isImageAvailable=1'
                    }
                    
                    // Has Open Houses
                    if(this.filterOptions.items.openHouses){
                        if(searchFilters !== '') searchFilters += ' AND '
                        
                        let dateNow = Math.round(new Date().getTime()/1000.0)

                        searchFilters += 'isOpenHouseAvailable=1'
                    }

                    if(searchFilters !== ''){
                        console.log('Search filters: ', searchFilters)
                        
                        this.algoliaFilters = searchFilters
                    }else{
                        this.algoliaFilters = null
                    }
                }else{
                    this.algoliaFilters = null
                }
            },

            /**
             * Other Data
             */

            getResources(type){
                // if(type === 'bc_parks'){
                //     this.getBCParks()
                // }
                // else if(type === 'properties'){
                //     this.searchProperties()
                // }
            },
            getBCParks(){
                let cors = 'https://cors-anywhere.herokuapp.com/'
                let reqUrl = cors + 'http://bcparks.ca/_shared/json/parks.json?v=1599079699069'
                let dataFromStorage = window.localStorage.getItem('bc_parks')
                let useStorage = true

                if((typeof(dataFromStorage) !== 'undefined' && dataFromStorage !== null) && useStorage){
                    
                    dataFromStorage = JSON.parse(dataFromStorage)

                    this.parks = dataFromStorage
                    this.loading = false

                }else {
                    this.$http.get(reqUrl).then(res => {
                        console.log('Data loaded from remote: ', res.body.parks)

                        if(res.status === 200){
                            this.parks = res.body.parks
                            window.localStorage.setItem('bc_parks', JSON.stringify(res.body.parks))
                        }

                        this.loading = false

                    }).catch(error => {
                        console.log('Error getting data: ', error)
                        this.loading = false
                    })
                }
            },
            
            /**
             * Maps
             */

            async initMap(event){

                // Setup Map
                this.map = event.map
                this.asyncActions = event.component.actions

                // Controls
                this.map.addControl(new Mapbox.NavigationControl({
                    position: 'bottom-right'
                }))
                this.map.addControl(new Mapbox.GeolocateControl({
                    positionOptions: {
                        enableHighAccuracy: true
                    },
                    trackUserLocation: true
                }))
                this.map.addControl(new MapboxStyleSwitcherControl())

                // Draw Option
                this.Draw = new MapboxDraw({
                    displayControlsDefault: false,
                    controls: {
                        polygon: true,
                        trash: true
                    }
                })
                this.map.addControl(this.Draw, 'top-left')

                this.map.on('draw.create', (e) => {
                    let data = this.Draw.getAll()
                    let algoliaPoints = this.getAlgoliaCoordinates(data.features[0].geometry.coordinates)

                    console.log('Draw polygon created!', algoliaPoints)

                    this.searchType = 'polygon_draw'
                    this.drawPolygon = true
                    this.polygonSearch = algoliaPoints
                    this.properties = []
                    this.page = 1
                    this.clearMarkers()
                    this.searchProperties()
                })
                this.map.on('draw.delete', (e) => {

                    console.log('Draw polygon removed!')

                    this.searchType = 'boundary'
                    this.drawPolygon = false
                    this.polygonSearch = null
                    this.properties = []
                    this.page = 1
                    this.clearMarkers()
                    this.searchProperties()
                })
                this.map.on('draw.update', (e) => {
                    let data = this.Draw.getAll()
                    let algoliaPoints = this.getAlgoliaCoordinates(data.features[0].geometry.coordinates)

                    console.log('Draw polygon updated!', algoliaPoints)

                    this.searchType = 'polygon_draw'
                    this.drawPolygon = true
                    this.polygonSearch = algoliaPoints
                    this.properties = []
                    this.page = 1
                    this.clearMarkers()
                    this.searchProperties()
                })
                this.map.on('draw.modechange', (e) => {
                    const data = this.Draw.getAll()

                    if (this.Draw.getMode() == 'draw_polygon') {
                        let pids = []

                        const lid = data.features[data.features.length - 1].id

                        data.features.forEach((f) => {
                            if (f.geometry.type === 'Polygon' && f.id !== lid) {
                                pids.push(f.id)
                            }
                        })
                        this.Draw.delete(pids)
                    }
                })
                
                // Create Popup
                this.popup = new Mapbox.Popup({
                    maxWidth: '300px'
                })

                // Map Events
                this.map.on('moveend', () => {
                    if(this.searchType !== 'polygon_area'){
                        this.loading = true
                        this.bounds = this.map.getBounds()
                        this.properties = []
                        this.page = 1
                        this.clearMarkers()
                        this.searchProperties()
                    }
                })

                // Markers & Layers
                this.bounds = this.map.getBounds()
                this.markers = []
                this.searchProperties()

                this.setDataLayers()
            },
            setDataLayers(){
                
                /**
                 * BC Areas
                 */

                this.map.addSource('bc_areas', {
                    'type': 'geojson',
                    'data': bcAreasData,
                    'generateId': true
                })
                this.map.addLayer({
                    'id': 'bc_area_layer',
                    'type': 'fill',
                    'source': 'bc_areas',
                    'layout': {
                        'visibility': 'visible'
                    },
                    'paint': {
                        'fill-color': '#005edc',
                        'fill-opacity': 0.1,
                        'fill-outline-color': '#fff',
                        'fill-opacity': [
                            'case',
                            ['boolean', ['feature-state', 'hover'], false],
                            0.2,
                            0.1
                        ]
                    },
                    'filter': ['==', '$type', 'Polygon']
                })
                this.map.addLayer({
                    'id': 'bc_area_borders',
                    'type': 'line',
                    'source': 'bc_areas',
                    'layout': {
                        'visibility': 'visible'
                    },
                    'paint': {
                        'line-color': '#fff',
                        'line-width': 2,
                        'line-opacity': 0.08,
                        'line-color': [
                            'case',
                            ['boolean', ['feature-state', 'hover'], false],
                            '#F4C439',
                            '#fff'
                        ],
                        'line-opacity': [
                            'case',
                            ['boolean', ['feature-state', 'hover'], false],
                            0.4,
                            0.08
                        ]
                    },
                    'filter': ['==', '$type', 'Polygon']
                })

                this.map.on('click', 'bc_area_layer', (e) => {

                    if(typeof(this.markerClickId) !== 'undefined'){
                        if(this.markerClickId !== null){
                            return
                        }
                    }
                    if(this.Draw.getMode() === 'draw_polygon'){
                        return
                    }
                    
                    if(!this.searchType !== 'polygon_draw'){
                        if(e.features.length > 0){

                            let areaName = e.features[0].properties.title
                            let algoliaCoordinates = JSON.parse(e.features[0].properties.algoliaPoints)

                            if(this.bcAreaClickId){
                                this.map.setFeatureState(
                                    { source: 'bc_areas', id: this.bcAreaClickId },
                                    { hover: false }
                                )
                                this.bcAreaClickId = null
                                this.bc_area_info = null
                                this.bounds = this.map.getBounds()
                                this.searchType = 'boundary'
                                this.polygonSearch = null
                            }else{
                                this.bcAreaClickId = e.features[0].id

                                this.map.setFeatureState(
                                    { source: 'bc_areas', id: this.bcAreaClickId },
                                    { hover: true }
                                )

                                this.bc_area_info = areaName
                                this.searchType = 'polygon_area'
                                this.polygonSearch = algoliaCoordinates
                            }

                            this.properties = []
                            this.page = 1
                            this.clearMarkers()
                            this.searchProperties()
                        }
                    }
                })
                this.map.on('mousemove', 'bc_area_layer', (e) => {
                    
                    if(this.Draw.getMode() === 'draw_polygon'){
                        return
                    }

                    if(!this.searchType !== 'polygon_draw'){
                        if(e.features.length > 0){

                            if(!this.bcAreaClickId){

                                this.map.getCanvas().style.cursor = 'pointer'
                                let areaName = e.features[0].properties.title

                                if(this.bcAreaHoverId){
                                    this.map.setFeatureState(
                                        { source: 'bc_areas', id: this.bcAreaHoverId },
                                        { hover: false }
                                    )
                                    this.bc_area_info = null
                                }

                                this.bcAreaHoverId = e.features[0].id

                                this.map.setFeatureState(
                                    { source: 'bc_areas', id: this.bcAreaHoverId },
                                    { hover: true }
                                )
                                this.bc_area_info = areaName
                            }
                        }
                    }
                })
                this.map.on('mouseleave', 'bc_area_layer', () => {
                    if(!this.searchType !== 'polygon_draw'){
                        
                        this.map.getCanvas().style.cursor = ''

                        if(!this.bcAreaClickId){
                            if(this.bcAreaHoverId) {
                                this.map.setFeatureState(
                                    { source: 'bc_areas', id: this.bcAreaHoverId },
                                    { hover: false }
                                )
                                this.bcAreaHoverId = null
                                this.bc_area_info = null
                            }
                        }
                    }
                })

                /**
                 * Parks
                 */

                this.map.addSource('bc_parks', {
                    'type': 'geojson',
                    'data': parksData
                })
                this.map.addLayer({
                    'id': 'bc_park',
                    'source': 'bc_parks',
                    'type': 'symbol',
                    'layout': {
                        'icon-image': 'park-15',
                        'icon-padding': 0,
                        'icon-allow-overlap': true
                    },
                    'paint': {
                        'icon-color': '#F4C439'
                    }
                })
                this.map.on('mouseenter', 'bc_park', (e) => {
                    this.map.getCanvas().style.cursor = 'pointer'
                    let coordinates = e.features[0].geometry.coordinates.slice()
                    this.popup.setLngLat(coordinates)
                        .setHTML(e.features[0].properties.title)
                        .addTo(this.map)
                })
                this.map.on('mouseleave', 'bc_park', () => {
                    this.map.getCanvas().style.cursor = ''
                    this.popup.remove()
                })

            },
            async panTo(type, data){
                
                let lat,
                    lng,
                    coordinates,
                    html,
                    zoom = 9,
                    speed = 1
                
                this.closePopups()

                if(type === 'park'){
                    let p = data.coordinates.split(',')

                    lat = parseFloat(p[0])
                    lng = parseFloat(p[1])
                    coordinates = [lat, lng]

                    html = '<div class="popupContent park">' + data.ParkNameBasic + '</div>'

                }else if(type === 'property'){
                    coordinates = [data._geoloc.lng, data._geoloc.lat]
                    zoom = 16
                    html = this.getPropertyHtml(data)
                }
                
                if(coordinates !== null){
                    await this.asyncActions.flyTo({
                        center: coordinates,
                        zoom: zoom,
                        speed: speed
                    }).then(() => {
                        this.popup.setLngLat(coordinates)
                            .setHTML(html)
                            .addTo(this.map)
                    })
                }
            },
            openPopup(type, data){

                let lat,
                    lng,
                    coordinates,
                    html

                if(type === 'property'){

                    coordinates = [data._geoloc.lng, data._geoloc.lat]
                    html = this.getPropertyHtml(data)

                    this.closePopups()
                    this.popup.setLngLat(coordinates)
                        .setHTML(html)
                        .addTo(this.map)
                }
            },
            closePopups(){
                if(this.popup !== null){
                    this.popup.remove()
                }
            },
            addMarkers(){

                if(this.properties !== null){

                    this.properties.forEach((property) => {

                        if(property._geoloc.lat === null) return

                        // Create Marker Element
                        let el = document.createElement('div')
                        let classes = 'marker property'

                        if(property.status === 'Sold'){
                            classes += ' sold'
                        }
                        el.className = classes
                        el.id = 'marker_'+ property.mls_no
                        el.data = property

                        // Marker Settings
                        let marker = new Mapbox.Marker(el)
                        let propertyCoordinates = [property._geoloc.lng, property._geoloc.lat]
                        
                        marker.setLngLat(propertyCoordinates)
                            .addTo(this.map)

                        el.addEventListener('click', (e) => {
                            this.openModal(e.target.data)
                            this.markerClickId = e.target.data.mls_no
                        })
                        el.addEventListener('mouseenter', (e) => {
                            this.closePopups()
                            e.target.classList.add('active')
                            this.popup.setLngLat(propertyCoordinates)
                                .setHTML(this.getPropertyHtml(e.target.data))
                                .addTo(this.map)
                        })
                        el.addEventListener('mouseleave', (e) => {
                            this.closePopups()
                            e.target.classList.remove('active')
                        })

                        this.markers.push(marker)
                    })
                }
            },
            clearMarkers(){
                if(typeof(this.markers) !== 'undefined' && this.markers !== null){
                    for (let i = 0; i < this.markers.length; i++) {
                        this.markers[i].remove()
                    }
                    this.markers = []
                }
            },
            removePolygonArea(){
                if(this.bcAreaClickId){
                    this.map.setFeatureState(
                        { source: 'bc_areas', id: this.bcAreaClickId },
                        { hover: false }
                    )
                }
                this.bcAreaClickId = null
                this.bc_area_info = null
                this.bounds = this.map.getBounds()
                this.searchType = 'boundary'
                this.polygonSearch = null
                this.properties = []
                this.page = 1
                this.clearMarkers()
                this.searchProperties()
            },

            /**
             * Filter Events
             */

            filterUpdated(){
                this.page = 1
                this.properties = []
                this.clearMarkers()
                this.searchProperties()
            },
            filterCheckbox(id){
                this.filterOptions.items[id] = !this.filterOptions.items[id]
                this.filterUpdated()
            },
            clearFilters(){
                if(this.searchType === 'polygon_area'){
                    this.removePolygonArea()
                }else if(this.searchType === 'polygon_draw'){
                    this.Draw.trash()
                }
                this.filterOptions.items = {
                    city: '',
                    sub_area: '',
                    status: '',
                    hasImage: false,
                    openHouse: false,
                    propertyType: ''
                }
                this.filterUpdated()
            },
            
            /**
             * Helpers
             */

            setShowingInfo(data){
                let total = data.nbHits
                let currentTotal = ((data.page + 1) * data.hitsPerPage)
                this.maxHits = false

                if(total < currentTotal){
                    currentTotal = total
                    this.maxHits = true
                }
                if(this.page === data.nbPages){
                    this.maxHits = true
                }

                this.showingInfo = 'Showing: '+
                    ((data.page + 1) * data.hitsPerPage - data.hitsPerPage) + ' - ' +
                    currentTotal + ' of ' +
                    total +
                    ' (Page: '+ (data.page + 1) + ' / ' + data.nbPages +')'
            },
            handleScroll(){
                if(!this.maxHits){
                    if(!this.moreLoading){
                        if(this.$refs.propertiesList.scrollTop === this.$refs.propertiesList.scrollHeight - this.$refs.propertiesList.clientHeight){

                            this.page += 1
                            this.moreLoading = true
                            this.properties = []
                            this.clearMarkers()
                            this.searchProperties()
                        }
                    }
                }
                if(this.$refs.propertiesList.scrollTop > 300){
                    this.showScrollToTopBtn = true
                }else{
                    this.showScrollToTopBtn = false
                }
            },
            scrollTo(position){
                let listEl = this.$refs.propertiesList
                listEl.scrollTo({
                    top: position,
                    left: 0,
                    behavior: 'smooth'
                })
            },
            filter_toggle(item){
                this.filterItem = item
                // this.loading = true
                // this.showListings = true
                // this.getResources()
            },
            imgPlaceholder(e, path){
                // console.log('Path: ', path)
                e.target.src = 'http://bcparks.ca/explore/parkpgs/images/park_general_300.jpg'
            },
            isNewProperty(propertyTms){
                if(typeof(propertyTms) !== 'undefined'){

                    let startDate = moment.unix(propertyTms.entry_date_tms).utc().local();
                    let today = moment.utc().local();
                    let diff = startDate.diff(today, 'days');

                    if(diff === 0 || diff === -1 || diff === -2){
                        return true
                    }
                }
            },
            openModal(property){
                this.property = property
                this.showModal = true
            },
            closeModal(){
                this.property = null
                this.showModal = false
                this.markerClickId = null
            }
        },
        computed: {
            filteredList(){
                return this.parks.filter(item => {
                    return item.ParkNameBasic.toLowerCase().includes(this.searchText.toLowerCase())
                })
            }
        },
        filters: {
            formatPrice(value){
                let val = (value/1).toFixed(0)
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            fullAddress(property){
                let address = ''
                if(property.location.address !== ''){
                    if(address !== '') address += ' '
                    address += (property.location.address).toLowerCase()
                }
                if(property.location.city !== ''){
                    if(address !== '') address += ', '
                    address += property.location.city
                }
                return address
            },
            propertyType(value){
                if(value === 'Apartment/Condo'){
                    return 'Condo'
                }else if(value === 'House/Single Family'){
                    return 'House'
                }else{
                    return value
                }
            },
            propertyAddedDate(propertyTms){
                if(typeof(propertyTms) !== 'undefined'){

                    let startDate = moment.unix(propertyTms.entry_date_tms).utc().local();
                    let today = moment.utc().local();
                    let diff = startDate.diff(today, 'days');

                    if(diff === 0 || diff === -1 || diff === -2){
                        return startDate.fromNow()
                    }
                }
                return propertyTms
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/Resources.vue